import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import {
  chartOptions,
  chartLineDataStyled,
  chartLineDataStyledWithColorIndicator,
  percentChartOptions,
} from '@/utils/charts';
import ChartComponent from './Chart.component';

type ChartContainerProps = {
  labels: string[];
  data: number[];
  title: string;
  isPercentChart?: boolean;
  lineWithColorIndicator?: boolean;
  colorIndicator?: string;
  height?: string;
  tooltipLabel?: string;
  children?: React.ReactNode;
};

const ChartContainer = function ({
  labels,
  data,
  title,
  isPercentChart = false,
  lineWithColorIndicator = false,
  colorIndicator,
  height,
  tooltipLabel = 'Answer average',
  children,
}: ChartContainerProps): JSX.Element {
  const theme = useTheme();

  const options = useMemo(
    () => (isPercentChart ? percentChartOptions() : chartOptions()),
    [isPercentChart]
  );

  const lineData = useMemo(() => {
    if (lineWithColorIndicator && colorIndicator) {
      return chartLineDataStyledWithColorIndicator({
        labels,
        data,
        tooltipLabel,
        colorIndicator,
      });
    }

    return chartLineDataStyled({
      labels,
      data,
      theme,
      tooltipLabel,
    });
  }, [lineWithColorIndicator, labels, data, theme, tooltipLabel, colorIndicator]);

  return (
    <ChartComponent title={title} height={height} options={options} lineData={lineData}>
      {children}
    </ChartComponent>
  );
};

export default ChartContainer;
